import { Form, Input, Select, Button, Switch } from "antd";
import {
  ICreateBriefPayment,
  PAYMENT_TYPE,
} from "@shared/lib/types/briefPayment";
import { useGetBriefPaymentFacets } from "@entities/brief/lib/hooks/useGetBriefPaymentFacets";
import { formatData } from "@shared/lib/utils/formatData";
import { InputNumber } from "@shared/ui/InputNumber";
interface CreateBriefPaymentEntryProps {
  onSubmit: (values: ICreateBriefPayment) => void;
  isSubmitting: boolean;
  onCancel: () => void;
}

export function CreateBriefPaymentEntry({
  onSubmit,
  isSubmitting,
  onCancel,
}: CreateBriefPaymentEntryProps) {
  const [form] = Form.useForm();

  const typeOptions = Object.values(PAYMENT_TYPE).map((item) => ({
    label: item,
    value: item,
  }));

  const handleSubmit = (values: ICreateBriefPayment) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        isTdsDeducted: false,
        isTdsReceived: false,
      }}
    >
      <Form.Item
        name="title"
        label="Title"
        rules={[{ required: true, message: "Please enter title" }]}
      >
        <Input placeholder="Enter title" />
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Please select type" }]}
      >
        <Select placeholder="Select type" options={typeOptions} />
      </Form.Item>

      <Form.Item
        name="proofUrl"
        label="Proof URL"
        rules={[{ required: true, message: "Please enter proof URL" }]}
      >
        <Input placeholder="Enter proof URL" />
      </Form.Item>

      <Form.Item
        name="isTdsDeducted"
        label="TDS Deducted"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.isTdsDeducted !== currentValues.isTdsDeducted
        }
      >
        {({ getFieldValue }) =>
          getFieldValue("isTdsDeducted") ? (
            <Form.Item
              name="tdsAmount"
              label="TDS Amount"
              rules={[{ required: true, message: "Please enter TDS amount" }]}
            >
              <InputNumber
                style={{ width: "100%" }}
                type="number"
                placeholder="Enter TDS amount"
              />
            </Form.Item>
          ) : null
        }
      </Form.Item>

      <Form.Item
        name="isTdsReceived"
        label="TDS Received"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>

      <Form.Item
        name="amountReceived"
        label="Amount Received"
        rules={[{ required: true, message: "Please enter amount received" }]}
      >
        <InputNumber
          style={{ width: "100%" }}
          type="number"
          placeholder="Enter amount received"
        />
      </Form.Item>

      <Form.Item>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={isSubmitting}>
            Create
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
